<template>
  <v-layout row justify-space-between align-center wrap class="mt-4 pt-2">
    <v-flex xs12 sm12 md4 lg5 xl5 class="mx-2 pt-4">
      <h2 class="mb-4 pl-2 pt-2">Education</h2>
      <v-card-text class="py-0">
        <v-timeline align-top dense>
          <v-timeline-item class="edu-exp" color="blue" large>
            <v-avatar class="avatar" slot="icon">
          <img src="https://silveroakuni.ac.in/upload/images/favicon64.png">
        </v-avatar>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold blue--text">JUL 2019 - 2023</div>
                <div class="caption font-weight-bold blue--text">(Pursuing)</div>
              </v-flex>
              <v-flex class="pl-3">
                <strong>BE, Computer Engineering</strong>
                <div class="caption mb-2">Silver Oak College of Engineering & Technology, Ahmedabad</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item class="edu-exp" color="blue" large>
        <v-avatar class="avatar" slot="icon">
          <img src="https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/logos%2FUVA.png?alt=media&token=7071cd8b-6a25-4916-bec4-dab12f531202">
        </v-avatar>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold blue--text">Mar 2019</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>HSC</strong>
                <div class="caption mb-2">Ultra Vision Academy, Surendranagar</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item class="edu-exp" color="blue" large>
             <v-avatar class="avatar" slot="icon">
          <img src="https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/logos%2FSoaring%20High%20logo.png?alt=media&token=7ce560e9-13a0-4562-a01a-40fcac21941b">
        </v-avatar>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold blue--text">MAR 2017</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>SSC</strong>
                <div class="caption mb-2">Saint Hilary School, Dhrangadhra</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-flex>
    <v-flex xs12 sm12 md4 lg5 xl5 class="mx-2 pt-4">
      <h2 class="mb-4 pl-2">Experience</h2>
      <v-card-text class="py-0">
        <v-timeline align-top dense>

          <v-timeline-item class="edu-exp" color="blue" large>
            <v-avatar class="avatar" slot="icon">
          <img src="http://ieee.socet.edu.in/wp-content/uploads/2021/01/favicon.png">
        </v-avatar>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold blue--text">JAN 2022 </div>
                <div class="caption font-weight-bold blue--text">- Present</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Treasurer</strong>
                <div class="caption mb-2">Silver Oak University IEEE SB </div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item class="edu-exp" color="blue" large>
            <v-avatar class="avatar" slot="icon">
          <img src="https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/logos%2Fmarkinfinity.png?alt=media&token=1d6f3c77-d96b-4cbf-a513-69d5fa7f1a76">
        </v-avatar>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold blue--text">APR 2022 </div>
                <div class="caption font-weight-bold blue--text">- AUG 2022</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Graphic Designer & Video Editor</strong>
                <div class="caption mb-2">Markinfinity </div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item class="edu-exp" color="blue" large>
            <v-avatar class="avatar" slot="icon">
          <img src="http://ieee.socet.edu.in/wp-content/uploads/2021/01/favicon.png">
        </v-avatar>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold blue--text">MAR 2021 </div>
                <div class="caption font-weight-bold blue--text">- FEB 2022</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Marketing Committee Chair</strong>
                <div class="caption mb-2">Silver Oak University IEEE SB</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item class="edu-exp" color="blue" large>
             <v-avatar class="avatar" slot="icon">
          <img src="https://mishraeducationalinstitute.in/assets1/ico/favicon.png">
        </v-avatar>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold blue--text">AUG 2020 </div>
                <div class="caption font-weight-bold blue--text">- DEC 2021</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Graphic Designer</strong>
                <div class="caption mb-2">Mishra Educational Institute, Dhrangadhra</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>
          <v-timeline-item class="edu-exp" color="blue" large>
             <v-avatar class="avatar" slot="icon">
          <img src="https://mishraeducationalinstitute.in/assets1/ico/favicon.png">
        </v-avatar>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold blue--text">AUG 2020</div>
                <div class="caption font-weight-bold blue--text">- DEC 2021</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Webmaster</strong>
                <div class="caption mb-2">Mishra Educational Institute, Dhrangadhra</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-flex>
    <v-layout row justify-space-between align-center wrap class="mt-4 pt-2">
      <v-flex xs12 sm12 md4 lg5 xl5 class="mx-2 pt-4">
        <h2>
          <span>Designing</span>

          <span class="blue--text">Skills</span>
        </h2>
        <br>
          <div style="display:flex; justify-content:space-between; flex-wrap:wrap">
          <div  v-for="item in DesignSkills"
            :key="item.name">
              <v-chip style="border-radius:5px" color="#2196f3" text-color="white" label class="skill-box pa-2">
                <v-img
                      class="skill-icon"
                      :src="item.img"
                      height="40"
                      width="40"
                      style="border-radius:50%; border: 2px solid #fff;"
                      :alt="CodingSkills.name"
                      lazy-src="https://unra.go.ug/assets/loaders/loader_2.gif"
                    ></v-img>
              <h3 class="pl-3">
              {{item.name}}
              </h3>
            </v-chip>
          </div>
      </div>
    
      </v-flex>
      <v-flex xs12 sm12 md4 lg5 xl5 class="mx-2 pt-4">
        <h2>
          <span>Technical</span>
          <span class="blue--text">Skills</span>
        </h2>
        <br>
        <div style="display:flex; justify-content:space-between; flex-wrap:wrap">
          <div  v-for="item in CodingSkills"
            :key="item.name">
              <v-chip style="border-radius:5px" color="#2196f3" text-color="white" label class="skill-box pa-2">
                <v-img
                      class="skill-icon"
                      :src="item.img"
                      height="40"
                      width="40"
                      style="border-radius:50%; border: 2px solid #fff;"
                      :alt="CodingSkills.name"
                      lazy-src="https://unra.go.ug/assets/loaders/loader_2.gif"
                    ></v-img>
              <h3 class="pl-3">
              {{item.name}}
              </h3>
            </v-chip>
          </div>
      </div>
      </v-flex>
       <v-flex xs12 sm12 md6 lg5 xl6 class="mx-2 pt-4">
        <div style="display:flex;align-content: flex-start;flex-wrap:wrap;">
        <h2 class="mb-2 pl-2 pt-2 mt-4">Certifications <span class="blue--text">&</span> Badges</h2> 
          <div class="ml-3">
            <ul>
              <li v-for="item in Certificates"
            :key="item.name">
                <strong style="font-size:1.3rem">{{item.name}}</strong>
                <div class="blue--text">{{item.by}}</div>
                <div class="mb-2">{{item.desc}}<span> <a :href="item.link" target="_blank">{{item.linkTxt}}</a></span></div>
              </li>
            </ul>
          </div>
        </div>
       </v-flex> 
       <v-flex xs12 sm12 md4 lg5 xl5 class="mx-2 pt-4">
        <h2 class="mb-2 pl-2 pt-2 mt-4">Talks</h2> 
        <div class="ml-3">
        <ul>
            <li v-for="item in Talks" :key="item.name">
                <strong style="font-size:1.3rem">{{item.name}}</strong>
                <div class="blue--text"><a :href="item.link" style="text-decoration:none;" target="_blank">{{item.details}}</a></div>
                <div class="mb-2">{{item.desc}}</div>
            </li>
        </ul>
        </div>
       </v-flex>
      </v-layout>
      <div class="mt-4 pt-20" style="margin:auto;">
        <v-btn
          href="http://mnlinks.ml/eresume"
          target="_blank"
          color="blue"
          dark
          large
        >
          Download Resume
          <v-icon right dark>fas fa-file-download</v-icon>
        </v-btn>
      </div>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  metaInfo: {
    title: "Resume",
    titleTemplate: "%s ← Midhun Nair",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Vue HTML CSS JavaScript Design Adobe XD Photoshop Coding Skills Resume Work Web Developer Front-End",
      },
      { charset: "utf-8" },
      { property: "og:title", content: "Midhun Nair" },
      { property: "og:site_name", content: "Midhun Nair" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "http://midhunnair.live" },
      {
        property: "og:image",
        content:
          "https://cdn.image4.io/mndesigns/f_auto/66aa3e55-542a-4355-acb3-2602e5d55414.png",
      },
      {
        property: "og:description",
        content:
          "Vue HTML CSS JavaScript Design Adobe XD Photoshop Coding Skills Resume Work Web Developer Front-End",
      },
    ],
  },
  data() {
    return {
      CodingSkills: [
        {
          name: "HTML5",
          img: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/Skills%2FTechnical%2Fhtml.png?alt=media&token=cf06debd-a6b6-40f9-a90f-616a2e2c50f4",
        },
        {
          name: "CSS3",
          img: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/Skills%2FTechnical%2Fcss.png?alt=media&token=d795a04b-ed87-42e1-9879-3e682a54e5fa",
        },
        {
          name: "Javascript",
          img: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/Skills%2FTechnical%2Fjds.png?alt=media&token=1d8fe97d-cf8d-4137-adf1-8c24c7aed0cc",
        },
        {
          name: "Bootstrap",
          img: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/Skills%2FTechnical%2Fbootstrap.png?alt=media&token=d593bbb3-053e-46cb-8a80-9c9c3d6fcd23",
        },
        {
          name: "Vue.js",
          img: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/Skills%2FTechnical%2Fvue.png?alt=media&token=3882552a-99eb-493a-9206-2b4933ae80a3",
        },
        {
          name: "SQL",
          img: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/Skills%2FTechnical%2Fdb.png?alt=media&token=32172194-1f74-4505-85fd-a6e19b72272a",
        },
        {
          name: "Google Firebase",
          img: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/Skills%2FTechnical%2Ffirebase.png?alt=media&token=55726242-4bdf-4ece-9833-b24539e47a7e",
        },
        {
          name: "Google App Script",
          img: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/Skills%2FTechnical%2Fappscript.png?alt=media&token=4c5c1df2-8816-442d-a076-9a0984ff86ba",
        },
        {
          name: "Google Cloud Platform",
          img: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/Skills%2FTechnical%2Fgcp.png?alt=media&token=ef75a873-01c0-4caf-9f70-753e331fec67",
        },
        {
          name: "GitHub",
          img: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/Skills%2FTechnical%2Fgithub.png?alt=media&token=e5ede455-d89c-4e91-9139-8214d16cc94a",
        },
      ],
      DesignSkills: [
        {
          name: "Adobe Photoshop",
          img: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/Skills%2FCreative%2Fps.png?alt=media&token=2591d285-6200-4635-beb6-7898f36079ce",
        },
        {
          name: "Adobe Illustrator",
          img: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/Skills%2FCreative%2Fai.png?alt=media&token=72dfabf2-46d8-4045-90e7-978752efcb45",
        },
        {
          name: "Canva",
          img: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/Skills%2FCreative%2Fcanva.png?alt=media&token=63068139-e572-4957-8fbd-b5a5ebff84aa",
        },
        {
          name: "Premier Pro",
          img: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/Skills%2FCreative%2Fpr.png?alt=media&token=07b7a462-ec9e-4ed4-ba0b-1361b9b6e655",
        },
        {
          name: "XD",
          img: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/Skills%2FCreative%2Fcd.png?alt=media&token=1a6a9a32-d107-4913-81c1-022270bfc3c1",
        },
        {
          name: "Figma",
          img: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/Skills%2FCreative%2Ffigma.png?alt=media&token=65a8d8ae-235b-4dd0-8509-2d9e0aa98b4c",
        },
      ],
      Certificates: [
        {
          name: "Finalist",
          by: "Smart India Hackathon, 2022 (Software Edition)",
          desc: "Selected as finalist for the Grand Finale of the Smart India Hackathon, 2022 organized by Ministry of Education (Govt. of India), MoE’s Innovation Cell, AICTE and Presistent.",
          link: "https://drive.google.com/file/d/1kziwsgTDGbPDfBOC_h81_klcfnNVoV4r/view",
          linkTxt: "(Certificate)",
        },
        {
          name: "Oracle Database Foundation Course",
          by: "by Oracle Academy",
          desc: "Completed and Earned the Certificate of the Oracle Database Foundation Course.",
          link: "https://drive.google.com/file/d/1TE2KkWJ0XCiX5S9U9PRGWVb53p-Pklcm/view",
          linkTxt: "(Certificate)",
        },
        {
          name: "Google Cloud Ready Facilitator Program",
          by: "by Google Cloud Education",
          desc: "Participated in the Google Cloud Facilitator Program and Achieved 15+ labs and 5+ skill badges of Qwiklabs.",
          link: "https://www.cloudskillsboost.google/public_profiles/a465066c-13ba-4874-8924-bb54e5759342",
          linkTxt: "(Quicklabs Public Profile)",
        },
      ],
      Talks: [
        {
          name: "Know your PC 2.0",
          details: "Details",
          link: "https://events.vtools.ieee.org/m/313652",
          desc: "A talk on Computer Components and Hardware Components, with an hands-on assembly of the PC Components.",
        },
        {
          name: "What after index.html",
          details: "Details",
          link: "https://events.vtools.ieee.org/m/277873",
          desc: "The talk revolved around the topic “What after Index.html?”. The talk highlighted, what to be done once a developer develops a website in his local machine, Many free solutions were also presented to make their website accessible across the globe.",
        },
        {
          name: "Creative Graphics",
          desc: "The talk on different types of graphics, images and colour profiles. A basic overview of Graphic Designing Softwares like Adobe Photoshop, Illustrator, Canva etc were also shown in the talk.",
        },
      ],
    };
  },
};
</script>
<style scoped>
.skill-box:hover .skill-icon {
  transform: scale(1.2);
  transition: 0.2s;
}
.edu-exp:hover .avatar {
  transform: scale(1.2);
  border: 25px solid #2196f3;
  /* border-color: #2196f3; */
  transition: 0.2s;
}
</style>

